import { render, staticRenderFns } from "./form-timeline-task.vue?vue&type=template&id=72a21c0a&scoped=true&"
import script from "./form-timeline-task.vue?vue&type=script&lang=js&"
export * from "./form-timeline-task.vue?vue&type=script&lang=js&"
import style0 from "./form-timeline-task.vue?vue&type=style&index=0&id=72a21c0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a21c0a",
  null
  
)

export default component.exports